import { render, staticRenderFns } from "./LoginCard.ts.vue?vue&type=template&id=766c20b0"
import script from "./LoginCard.ts.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginCard.ts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LoginCard.ts.vue?vue&type=style&index=0&id=766c20b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports